import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/dashboard/productos`

export default ({ bankId, creditLineId }) => http.get(`${api}/${bankId}/${creditLineId}`)
